import { Component } from 'preact';
import RuneSpinner from '../RuneSpinner';
import { TEXT_PRIMARY, TEXT_BODY, TEXT_MUTED } from '../../lib/medievalTheme';
import { t } from '../../localization/t';

const SET_LABELS = { beta: 'Beta', arthurian: 'Arthurian Legends', gothic: 'Gothic' };

function eventTitle(tournament) {
  const setKey = tournament.setKey || tournament.set_key || '';
  const set = SET_LABELS[setKey] || setKey;
  const kind = tournament.mode === 'sealed' ? t('Sealed') : t('Draft');
  return `${set} ${kind}`.trim();
}

function phaseHint(status) {
  switch (status) {
    case 'drafting': return t('Opening boosters. Pick and pass');
    case 'building': return t('Building your deck');
    case 'tournament': return t('Tournament in progress');
    default: return status;
  }
}

function TournamentRow({ tournament, onResume }) {
  const count = (tournament.participants || []).length;
  const cap = tournament.podSize || tournament.pod_size || count;
  const handleClick = () => onResume?.(tournament.id);
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleClick(); }
  };
  return (
    <div
      className="vh-save-row group"
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      aria-label={t('Resume {event}', { event: eventTitle(tournament) })}
    >
      <div className="flex flex-col gap-2 min-w-0">
        <div className="flex items-baseline gap-2 flex-wrap">
          <span
            className="text-sm font-semibold arena-heading"
            style={{ color: TEXT_PRIMARY, textShadow: '0 -1px 0 rgba(0,0,0,0.6), 0 1px 2px rgba(0,0,0,0.5)' }}
          >
            {eventTitle(tournament)}
          </span>
          <span className="text-[0.6875cqw]" style={{ color: TEXT_MUTED }}>
            {t('{count} / {cap} players', { count, cap })}
          </span>
        </div>
        <div className="text-xs italic" style={{ color: TEXT_BODY, opacity: 0.85 }}>
          {phaseHint(tournament.status)}
        </div>
      </div>
    </div>
  );
}

export default class TournamentList extends Component {
  render() {
    const { tournaments, loading, onResume } = this.props;
    if (loading) {
      return (
        <div className="flex justify-center py-8">
          <RuneSpinner size={48} />
        </div>
      );
    }
    if (!tournaments?.length) {
      return (
        <div className="vh-empty-state">
          <div className="vh-empty-state-headline">{t('No tournaments yet')}</div>
          <p className="vh-empty-state-hint">
            {t('Join a draft or sealed event and it appears here so you can return to it anytime until it finishes.')}
          </p>
        </div>
      );
    }
    return (
      <div className="flex flex-col gap-2">
        {tournaments.map((tournament) => (
          <TournamentRow key={tournament.id} tournament={tournament} onResume={onResume} />
        ))}
      </div>
    );
  }
}
